import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { block } from "../../../core";

var map = require("lodash/map");

var identity = require("lodash/identity");

export var Select =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Select, _React$PureComponent);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Select, [{
    key: "onChange",
    value: function onChange(e) {
      var setItems = this.props.setItems;
      var key = e.target.value;
      setItems([key]);
    }
  }, {
    key: "getSelectedValue",
    value: function getSelectedValue() {
      var _this$props$selectedI = this.props.selectedItems,
          selectedItems = _this$props$selectedI === void 0 ? [] : _this$props$selectedI;
      if (selectedItems.length == 0) return null;
      return selectedItems[0];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          mod = _this$props.mod,
          className = _this$props.className,
          items = _this$props.items,
          disabled = _this$props.disabled,
          showCount = _this$props.showCount,
          translate = _this$props.translate,
          countFormatter = _this$props.countFormatter;
      var bemBlocks = {
        container: block(mod).el
      };
      return React.createElement("div", {
        className: bemBlocks.container().mix(className).state({
          disabled: disabled
        })
      }, React.createElement("select", {
        onChange: this.onChange,
        value: this.getSelectedValue()
      }, map(items, function (_ref) {
        var key = _ref.key,
            label = _ref.label,
            title = _ref.title,
            disabled = _ref.disabled,
            doc_count = _ref.doc_count;
        var text = translate(label || title || key);
        if (showCount && doc_count !== undefined) text += " (".concat(countFormatter(doc_count), ")");
        return React.createElement("option", {
          key: key,
          value: key,
          disabled: disabled
        }, text);
      })));
    }
  }]);

  return Select;
}(React.PureComponent);
Select.defaultProps = {
  mod: "sk-select",
  showCount: true,
  translate: identity,
  countFormatter: identity
};